"use strict";

var classNames = require("classnames");
var LoggerInstance = require("js-logger").get("CartItemUseOnDay");
var React = require("react");

var CheckoutActions = require("./CheckoutActions");
var CheckoutStore = require("./CheckoutStore");

var CartItemUseOnDay = React.createClass({
	propTypes: {
		className: React.PropTypes.string,
		isDesignMode: React.PropTypes.bool,
		cartItemId: React.PropTypes.string,
		useOnDays: React.PropTypes.arrayOf(React.PropTypes.shape({
			description: React.PropTypes.string,
			value: React.PropTypes.string
		})),
		theme: React.PropTypes.string,
		isCustomTheme: React.PropTypes.bool,
		dataComponentId: React.PropTypes.string,
		dataNestedId: React.PropTypes.string,
		dataRepeatedId: React.PropTypes.string
	},

	handleChange: function (event) {
		CheckoutActions.setDonationUseOnDay(this.props.cartItemId, event.currentTarget.value);
		CheckoutActions.updateDonation(this.props.cartItemId);
	},

	getStateFromStore: function () {
		return {
			selectedUseOnDay: CheckoutStore.getDonationUseOnDay(this.props.cartItemId)
		};
	},

	_onChange: function () {
		this.setState(this.getStateFromStore());
	},

	componentDidMount: function () {
		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentLoaded(this);
		}
		CheckoutStore.addChangeListener(this._onChange);
	},

	componentWillUnmount: function () {
		CheckoutStore.removeChangeListener(this._onChange);

		if (this.props.isDesignMode) {
			parent.window.ComponentActions.childComponentUnloaded(this);
			CheckoutActions.setDonationUseOnDay(this.props.cartItemId, null);
		}
	},

	getDefaultProps: function () {
		return {};
	},

	getInitialState: function () {
		var state = this.getStateFromStore();
		var wizardUseOnDays = CheckoutStore.get("wizardUseOnDays") || { allowedUseOnDays: [] };
		var allowedUseOnDays = wizardUseOnDays.allowedUseOnDays || [];
		var useOnDays = this.props.useOnDays;
		var useOnDay;

		if (allowedUseOnDays && useOnDays) {
			for (var i = useOnDays.length - 1; i >= 0; --i) {
				useOnDay = useOnDays[i];
				var allowedIndex = allowedUseOnDays.indexOf(useOnDay.value);
				if (allowedIndex === -1) {
					// UseOnDay is not allowed
					useOnDays.splice(i, 1);
				} else if (useOnDay.useDefaultDescription) {
					// UseOnDay should use default description
					useOnDay.description = wizardUseOnDays[`${useOnDay.value}_Description`];
				}
			}
		} else {
			useOnDays = [];
		}

		state.useOnDays = useOnDays;

		return state;
	},

	render: function () {
		var selectedUseOnDay = this.state.selectedUseOnDay;
		var enabled = this.props.isDesignMode || CheckoutStore.getDonationFrequency(this.props.cartItemId) !== "O";
		var useOnDays = this.state.useOnDays;
		var showEmpty = !selectedUseOnDay || useOnDays.findIndex(useOnDay => (useOnDay.value || "").toString() === (selectedUseOnDay || "").toString()) === -1;

		return (
			<span
				data-react-component-name="CartItemUseOnDay"
				data-react-component-category="DonationCartItemComponents"
				data-component-id={this.props.dataComponentId}
				data-nested-id={this.props.dataNestedId}
				data-repeated-id={this.props.dataRepeatedId}
				data-theme={+this.props.theme ? this.props.theme : undefined}
				data-custom={this.props.isCustomTheme || null}
				data-child-of={this.props.dataChildOf}
			>
				<select
					value={selectedUseOnDay || ""}
					onChange={this.handleChange}
					className={classNames(this.props.className, {disabled: !enabled})}
					style={this.props.isDesignMode ? {"pointerEvents": "none"} : undefined}
					data-override-classes={this.props.className}
					disabled={!enabled}
				>
					{showEmpty &&
						<option value="" />
					}
					{useOnDays && useOnDays.map(useOnDay => {
						return (
							<option key={useOnDay.value} value={useOnDay.value}>
								{useOnDay.description}
							</option>
						);
					})}
				</select>
			</span>
		);
	}
});

module.exports = CartItemUseOnDay;



// WEBPACK FOOTER //
// ./Javascript/checkoutComponents/CartItemUseOnDay.jsx